"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/web.timers.js");

/*
 * 节流函数（疯狂操作，第一次触发后一段时间内其他都不触发）
 */

/**
 * @function Throttle - 节流函数
 * @desc 疯狂操作，第一次触发后一段时间内其他都不触发
 * @param {function} fun 可执行函数
 * @param {number} [delay] 需要延迟的时间，默认1000
 * @param {any} [params] 需要传给fun的参数，没有不传
 * @example
 * import { Throttle } from '@zz-biz/utils';
 *
 * Throttle(function(num){ console.log(num) }, 2000, 120)()
 *
 * // 在vue和react中不能使用下面写法，每次render都会生成新的函数对象，导致失效，如下
 * // 错误写法
 * <span onClick={() => Throttle(function(num){ console.log(num) }, 2000)()}>
 * // 正确写法
 * <span onClick={Throttle(function(num){ console.log(num) }, 2000)}>
 */
var Throttle = function Throttle(fun) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var params = arguments.length > 2 ? arguments[2] : undefined;

  if (!fun || Object.prototype.toString.call(fun) !== '[object Function]') {
    return function () {
      return console.warn('参数没有可执行函数');
    };
  }

  return function (args) {
    var that = this;
    var now = +new Date();

    if (fun.last && now < fun.last + delay) {
      // 对于input输入，还是需要再执行一次的
      clearTimeout(fun.timer);
      fun.timer = setTimeout(function () {
        fun.last = now;

        if (that) {
          fun.apply(that, params || args);
        } else {
          fun(params || args);
        }
      }, delay);
    } else {
      clearTimeout(fun.timer);
      fun.last = now;

      if (that) {
        fun.apply(that, params || args);
      } else {
        fun(params || args);
      }
    }
  };
};

var _default = Throttle;
exports["default"] = _default;